import {
  ApplicationTypes,
  EuroCylinderHoleAu,
  EuroCylinderHoleEu,
  attachComponent,
  featureLabels,
} from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const euroCylinderHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('EuroCylinderHoleEu')
    .attach(() => {
      return {
        title: featureLabels[EuroCylinderHoleEu.type],
        subtitle: 'European orientation',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/euro-cylinder-hole-eu.png',
      }
    }),
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('EuroCylinderHoleAu')
    .attach(() => {
      return {
        title: featureLabels[EuroCylinderHoleAu.type],
        subtitle: 'Australian orientation',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/euro-cylinder-hole-au.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withAlias('EuroCylinderHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withAlias('EuroCylinderHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  attachComponent
    .withAlias('EuroCylinderHole')
    .withComponent(dimensionIndicatorComponent, 'radiuses')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => {
      return {
        ...bendHoleDimensionIndicatorCoordinates(s, {
          startY: s.height / 2,
          endY: -s.height / 2,
          startX: 0,
          endX: 0,
          startZ: s.$plate.thickness + 0.1,
          endZ: s.$plate.thickness + 0.1,
        }),
        arrowHeadType: ArrowHeadType.CONE,
        arrowHeadSize: 4,
        labelFontSize: scaleIndicator(3, 48, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
        labelAngle: Math.PI / 2,
        label: `R=${s.bottomWidth / 2} / ${s.topWidth / 2}`,
      }
    }),
]
